//auth
export const LOGIN = "/api/auth/login";
export const LOGOUT = "/api/auth/logout";
export const FORGOT_PASSWORD = "/api/auth/password-reset-mail";
export const RESET_PASSWORD = "/api/auth/reset-password";
export const REGISTER = "/api/auth/register";

//Dashboard
export const DASHBOARDFORM = "api/dashboard/form";
export const DASHBOARDTASK = "api/dashboard/task"
export const DASHBOARDFORMRESPONSE = "api/dashboard/form-response";
export const DASHBOARDTOPTRIGGER = "api/dashboard/top-triggers";
export const DASHBOARDTASKCOMPLETION = "api/dashboard/task-completion";




//Form
export const FORM = "/api/form";

export const FORM_RESPONSE = "/api/formResponse";

//User
export const USER = "/api/user";

//File Upload
export const UPLOAD = "/api/upload";

//Categories
export const CATEGORY = "/api/category";
//notification
export const NOTIFICATION = "/api/notification";
//Role
export const ROLE = "/api/role";

//Task
export const TASK = "/api/task";

//Team
export const TEAM = "/api/team";

//Project
export const PROJECT = "api/project";

// Recurring

export const RECURRING = "/api/recurring"

//Announcement
export const ANNOUNCEMENT = "api/announcement";

// training
export const TRAINING = "api/training";

//access

export const ACCESS = "/api/access"

//Location
export const LOCATION = "/api/location";

//Report
export const REPORT = "/api/report";
export const REPORT_DASHBOARD_SUBMISSION_COUNT = "/api/report/dashboard/submissions-count";
export const REPORT_DASHBOARD_FIELD_RESPONSE_COUNT = "/api/report/dashboard/fields-response-count"
//data
export const PERMISSION = "/api/permission";
export const ENTITY = "/api/entity";
export const MASTER = "/api/master";
export const MASTER_UNIT = "/api/unit";
export const MASTER_PROPERTY = "/api/prop-code";
export const MASTER_WORR = "/api/worr";
export const MASTER_GL_CODE = "/api/gl-code";
export const PROP_WISE_UNIT = "/api/unit/property-code";

// export const masterGetAPIEndpoints = {
//   0: "/api/prop-code",
//   1: "api/cc-description",
//   2: "/api/unit",
//   3: "/api/gl-code",
// };

export const ROLE_PERMISSION = "/api/role-permission";
export const RECEIPT_WALLET = "/api/upload";
// export const USER = "/api/user"
export const USER_APPROVER = "/api/user-approver";
export const USER_ACCOUNT = "/api/user-account";


//trigger
export const TRIGGER = "/api/trigger";
//cc
export const UPLOAD_EXCEL = "/api/upload/excel";
export const EXTRACT_CC_DETAILS = "/api/cc-details/temp-cc-details";
export const ADMIN_CC_DETAILS = "/api/cc-details";
export const APPROVER_CC_DETAILS = "/api/cc-details/by-status";
export const USER_CC_DETAILS = "/api/cc-details/by-account";
export const UPDATE_CC_DETAILS = "/api/cc-details/cc-details";
export const ACCOUNT_DETAILS = "/api/account-details";
export const UPDATE_APPROVAL_STATUS = "/api/cc-details/update-status";
export const PENDING_BY_APPROVER = "/api/cc-details/pending-by-approver";
export const PENDING_BY_USER = "/api/cc-details/pending-by-user";
export const TOTAL_AMOUNT = "/api/cc-details/total-amount";
export const UPLOAD_PDF_ZIP = "/api/pdf-read";

// dummy
export const ROLES_DUMMY = "/roles";
export const PROJECTS_DUMMY = "/projects";
export const ACCESS_PERMISSION = "api/access";
export const COUNTRY = "api/country";

export const ALL_HIERARCHY = "api/hierarchy";
export const TEAM_LOCATION_HIERARCHY = "api/hierarchy/team-location";
export const ROLE_HIERARCHY = "api/hierarchy/role";
export const TEAM_HIERARCHY = "api/hierarchy/team";
export const SEARCH_HIERARCHY = "api/hierarchy/search";
export const USER_HIERARCHY = "api/user";
